import { useEffect, useState } from 'react';

import { FormField, FormHelp, Label, Textarea } from '@zillow/constellation-10';
import { CharacterCountFormHelp } from '@zg-rentals/visual-cohesion';

type Props = {
  initialValue?: string;
  isDisabled?: boolean;
  error?: string;
  maxLength?: number;
  // eslint-disable-next-line
  onClearError?: (value?: any) => void;
  handleCaptionBlur: (value: string) => void;
};

export const TextareaHelper = ({
  initialValue = '',
  isDisabled = false,
  error,
  maxLength = 255,
  onClearError,
  handleCaptionBlur,
}: Props) => {
  const [value, setValue] = useState(initialValue);
  const [isFocused, setIsFocused] = useState(false);

  const isOverLimit = value.length > maxLength;

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const handleOnChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (onClearError) {
      onClearError();
    }
    setValue(e.target.value);
  };

  const handleOnBlur = () => {
    setIsFocused(false);
    if (!isOverLimit) {
      handleCaptionBlur(value);
    }
  };

  return (
    <FormField
      css={{ marginBlock: 'tight' }}
      disabled={isDisabled}
      error={isOverLimit || Boolean(error)}
      label={<Label>Caption</Label>}
      control={
        <Textarea
          value={value}
          onChange={handleOnChange}
          onFocus={() => setIsFocused(true)}
          onBlur={handleOnBlur}
          css={{ resize: 'vertical' }}
        />
      }
      description={
        error ? (
          <FormHelp>{error}</FormHelp>
        ) : (
          <CharacterCountFormHelp
            currentLength={value.length}
            maxLength={maxLength}
            isFocused={isFocused}
            label="Caption"
          />
        )
      }
    />
  );
};
